module.exports = __webpack_public_path__ + "img/banner-luna-pc.0c1d5345.png";